
export default {
  name: 'PopUpLoading',

  computed: {
    isOpen: function () {
      return this.$store.state.loading.loading;
    },
  },
};
